import { Navigate } from "react-router-dom";
import { useAccessControl } from "@/hooks/useAccessControl";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
  requiredPermissions?: string[];
}

export function ProtectedRoute({ children, requiredRoles, requiredPermissions }: ProtectedRouteProps) {
  const { authUser, loading, roles, isAdmin, permissions } = useAccessControl();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gl-bg-light">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && requiredRoles.length > 0) {
    const normalizedRequired = requiredRoles.map((role) => role.toLowerCase());
    const hasRole = roles.some((role) => normalizedRequired.includes(role));
    if (!hasRole) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  if (requiredPermissions && requiredPermissions.length > 0 && !isAdmin) {
    const hasPermission = requiredPermissions.some((p) => permissions.includes(p));
    if (!hasPermission) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
}
